
export const CONSTANT_ROTATION_SPEED = 0.9; //恒定的旋转速度配置（弧度/秒）
export const BALLS_TO_SHOOT = 5; //初始发射的球数量
export const CORE_RADIUS = 40; //中心圆半径
export const ORBIT_RADIUS = 120; //轨道圆半径
export const BALL_RADIUS = 3;//小球半径
export const ADV_ROUND = 300000; //广告轮次间隔

/** 游戏状态枚举 */
export const GameStatus = {
  IDLE : 'IDLE',          // 待机/首屏
  PLAYING : 'PLAYING',    // 游戏中
  GAMEOVER : 'GAMEOVER',  // 游戏结束（碰撞）
  LEVEL_WIN : 'LEVEL_WIN',// 关卡完成
  PAUSED : 'PAUSED'       // 暂停
}

export const GameState = {
  status: GameStatus.IDLE,
  initialBalls: BALLS_TO_SHOOT,
  remainingBalls:0,
  level: 1,
  score: 0,
  revivalsUsed: 0,
  rotationSpeed: CONSTANT_ROTATION_SPEED,
}

